<div *ngIf="!isEdit">
  <div class="row mt-3 datePick">
    <mat-form-field>
      <mat-label>Pick date</mat-label>
      <input matInput [matDatepicker]="medPicker" [(ngModel)]="medSelectedDate" #medDateRange
        (dateChange)="extractMedicines(medDateRange)">
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="medPicker"></mat-datepicker-toggle>
      <mat-datepicker #medPicker></mat-datepicker>
    </mat-form-field>
  </div>
  <div class="row mt-2 button-row">
    <button class="btn applyBtn" (click)="editMeds()" [disabled]="editList.length<1">Edit</button>
    <button class="btn addBtn" (click)="openAddMedModal()">Add Medication</button>
  </div>
  <div class="col-md-12">

    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="Medications">
        <th mat-header-cell *matHeaderCellDef><b>Medications</b></th>
        <td mat-cell *matCellDef="let element"><b>{{element.name}}</b></td>
      </ng-container>
      <ng-container matColumnDef="MedTime">
        <th mat-header-cell *matHeaderCellDef><b>Med Taken Time</b></th>
        <td mat-cell *matCellDef="let element">
          <input type="time" class="form-control editField medFieldWide"
            [(ngModel)]="element.editableTakenTime"
            [ngModelOptions]="{standalone: true}"
            [disabled]="isFutureSelectedDate()"
            (mousedown)="onStatusDropdownInteraction($event)"
            (click)="onStatusDropdownInteraction($event)"
            (change)="onStatusDropdownInteraction($event)" />
        </td>
      </ng-container>
      <ng-container matColumnDef="Dosage">
        <th mat-header-cell *matHeaderCellDef><b>Dosage</b></th>
        <td mat-cell *matCellDef="let element">{{element.dosage}} {{element.unit}}</td>
      </ng-container>
      <ng-container matColumnDef="Quantity">
        <th mat-header-cell *matHeaderCellDef><b>Quantity</b></th>
        <td mat-cell *matCellDef="let element">{{element.quantity}}</td>
      </ng-container>
      <ng-container matColumnDef="Frequency">
        <th mat-header-cell *matHeaderCellDef><b>Frequency</b></th>
        <td mat-cell *matCellDef="let element">{{element.frequency}}</td>
      </ng-container>
      <ng-container matColumnDef="StartDate">
        <th mat-header-cell *matHeaderCellDef><b>Start Date</b></th>
        <td mat-cell *matCellDef="let element">{{element.startDate?.split('T')[0] | date:'MMMM dd, y'}}</td>
      </ng-container>
      <ng-container matColumnDef="Status">
        <th mat-header-cell *matHeaderCellDef><b>Status</b></th>
        <td mat-cell *matCellDef="let element">
          <select class="form-control editField medFieldWide"
            [ngClass]="{'disabled-select': isFutureSelectedDate()}"
            [(ngModel)]="element.editableStatus"
            [ngModelOptions]="{standalone: true}"
            (mousedown)="onStatusDropdownInteraction($event)"
            (click)="onStatusDropdownInteraction($event)"
            (change)="onStatusDropdownInteraction($event)">
            <option value="" disabled>Select Status</option>
            <option value="taken">Taken</option>
            <option value="unTaken">Untaken</option>
            <option value="skip">Skip</option>
          </select>
        </td>
      </ng-container>

      <ng-container matColumnDef="Update">
        <th mat-header-cell *matHeaderCellDef><b>Action</b></th>
        <td mat-cell *matCellDef="let element">
          <button class="btn updateBtnSmall btnLabel1" (click)="updateMedStatus(element)">Update</button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

</div>

<div *ngIf="isEdit">
  <div class="row mt-2">
    <button class="btn allBtn" (click)="viewMeds()">View Medications</button>
  </div>
  <div class="row">
    <div class="memberPartern mt-3 col-sm-5 ml-4" *ngFor="let med of editList">
      <div class="row mt-3">
        <div class="col-sm">
          <div class="col-md-12 labelContent">
            {{med.medicines[0].name}}
          </div>
        </div>
        <div class="col-sm">
          <div class="col-md-12 labels">
            <img style="width:20px;margin-left: 65%; cursor: pointer;" (click)="openEditMedModal(med)"
              src="assets/img/edit.png" />
            <img style="width:35px; margin-left: 15px; cursor: pointer;" (click)="openDelModal(med)"
              src="assets/img/del.png" />
          </div>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-sm">
          <div class="col-md-12 labels" *ngFor="let m of med.medicines">
            <div class="col mt-1">
              <span class="med-label">Dosage:</span> {{m.dosage}} {{m.unit}} &nbsp; <b>|</b>&nbsp; 
              <span class="med-label">Time:</span> {{m.time}} &nbsp; <b>|</b> &nbsp; 
              <span class="med-label">Qty:</span> {{m.quantity}} &nbsp;<b>|</b> &nbsp;
              <span class="med-label">From:</span> {{med.fromDate?.split('T')[0] | date:'MMMM dd, y'}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="editMedModal" tabindex="-1" aria-labelledby="editMedModalLabel" data-bs-backdrop="static"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content modal-size-style radius">
      <div class="modal-header">
        <span class="title1">Edit Medicine</span>
        <button type="button" class="close" aria-label="Close" data-bs-dismiss="modal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col modalText" *ngIf="editMedObj.medicines?.length>0">
            <div class="col-md-12">
              <span class="editSubText">Name:</span>
              <input type="text" disabled [(ngModel)]="editMedObj.medicines[0].name"
                class="form-control editField disableColor" />
            </div>
            <div class="col-md-12">
              <span class="editSubText">Frequency:</span>
              <select class="form-control editField" [(ngModel)]="editMedObj.frequency" (change)="onFreqChange()">
                <option value="Once daily">Once daily</option>
                <option value="Twice daily">Twice daily</option>
                <option value="Thrice daily">Thrice daily</option>
                <option value="Weekly">Weekly</option>
                <option value="Every 15 Days">Every 15 Days</option>
                <option value="Every 6 Months">Every 6 Months</option>
              </select>
            </div>
            <div class="col-md-12">
              <span class="editSubText">Dosage:</span>
              <div class="d-flex gap-2 align-items-center">
                <input type="number" class="form-control editField width25"
                  [(ngModel)]="editMedObj.medicines[0].dosage" />
                &nbsp;&nbsp;<select class="form-control editField width25" [(ngModel)]="editMedObj.medicines[0].unit">
                  <option value="mg">mg</option>
                  <option value="g">g</option>
                  <option value="mL">mL</option>
                  <option value="mcg">mcg</option>
                  <option value="drops">drops</option>
                  <option value="IU">IU</option>
                  <option value="puffs">puffs</option>
                </select>
              </div>
            </div>
            <div class="col-md-12">
              <span class="editSubText">From Date:</span>
              <input type="text" disabled class="form-control editField disableColor width40"
                [(ngModel)]="editMedObj.fromDate.split('T')[0]" />
            </div>
            <div class="col-md-12" *ngFor="let m of editMedObj.medicines">
              <span class="editSubText">Time:</span>
              <span class="editSubText left">Qty:</span>
              <div class="d-flex gap-2 align-items-center">
                <input type="time" class="form-control editField width25" [(ngModel)]="m.time"
                  [ngModelOptions]="{standalone: true}" />
                &nbsp;&nbsp;<input type="number" class="form-control editField width25" [(ngModel)]="m.quantity" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btnConfirm btnLabel" data-bs-dismiss="modal">Cancel</button>
        <button type="button" class="btn fastBtn btnLabel1" (click)="updateMed()">Update</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="delMedModal" tabindex="-1" aria- labelledby="delMedModalLabel" data-bs-backdrop="static"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content modal-size-style radius">
      <div class="modal-header">
        <span class="title1">Please Confirm!</span>
        <button type="button" class="close" aria-label="Close" data-bs-dismiss="modal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row mt-1">
          <div class="col modalText">Are you sure you want to delete the medicine?</div>
        </div>

      </div>
      <div class="modal-footer">
        <button class="btn fastBtn btnLabel1" (click)="deleteMed()">Yes</button>
        <button type="button" class="btnConfirm btnLabel" data-bs-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>

<!-- Add Medication Modal -->
<div class="modal fade" id="addMedModal" tabindex="-1" aria-labelledby="addMedModalLabel" data-bs-backdrop="static"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content modal-size-style radius">
      <div class="modal-header">
        <span class="title1">Add Medication</span>
        <button type="button" class="close" aria-label="Close" data-bs-dismiss="modal" (click)="resetAddMedForm()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col modalText">
            <!-- Medication Name -->
            <div class="col-md-12 mb-3">
              <span class="editSubText">Medication Name:</span>
              <input type="text" [(ngModel)]="newMedObj.name" class="form-control editField"
                placeholder="Medication Name" />
            </div>

            <!-- Frequency -->
            <div class="col-md-12 mb-3">
              <span class="editSubText">Frequency:</span>
              <select class="form-control editField" [(ngModel)]="newMedObj.frequency" (change)="onAddFreqChange()">
                <option value="" disabled selected>Frequency of Medication</option>
                <option value="Once daily">Once daily</option>
                <option value="Twice daily">Twice daily</option>
                <option value="Thrice daily">Thrice daily</option>
                <option value="Weekly">Weekly</option>
                <option value="Every 15 Days">Every 15 Days</option>
                <option value="Every 6 Months">Every 6 Months</option>
              </select>
            </div>

            <!-- Dosage and Unit -->
            <div class="col-md-12 mb-3">
              <span class="editSubText">Dosage:</span>
              <div class="d-flex gap-2 align-items-center">
                <input type="number" step="0.01" class="form-control editField width25" [(ngModel)]="newMedObj.dosage"
                  placeholder="Dosage" />
                &nbsp;&nbsp;
                <select class="form-control editField width25" [(ngModel)]="newMedObj.unit">
                  <option value="" disabled selected>Unit</option>
                  <option value="mg">mg</option>
                  <option value="g">g</option>
                  <option value="mL">mL</option>
                  <option value="mcg">mcg</option>
                  <option value="drops">drops</option>
                  <option value="IU">IU</option>
                  <option value="puffs">puffs</option>
                </select>
              </div>
            </div>

            <!-- Start Tracking Date -->
            <div class="col-md-12 mb-3">
              <span class="editSubText">Start Tracking Date:</span>
              <mat-form-field class="date-field">
                <input matInput [matDatepicker]="startDatePicker" [(ngModel)]="newMedObj.startDate"
                  [min]="minStartDate" placeholder="Select Date">
                <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #startDatePicker></mat-datepicker>
              </mat-form-field>
            </div>

            <!-- Time and Quantity (Dynamic based on frequency) -->
            <div class="col-md-12 mb-2" *ngFor="let med of newMedObj.medications; let i = index">
              <span class="editSubText">Time {{newMedObj.medications.length > 1 ? (i + 1) : ''}}:</span>
              <span class="editSubText left">Quantity:</span>
              <div class="d-flex gap-2 align-items-center">
                <input type="time" class="form-control editField width25" [(ngModel)]="med.time"
                  [ngModelOptions]="{standalone: true}" />
                &nbsp;&nbsp;
                <select class="form-control editField width25" [(ngModel)]="med.quantity"
                  [ngModelOptions]="{standalone: true}">
                  <option value="" disabled selected>Qty</option>
                  <option [ngValue]="0.5">0.5</option>
                  <option [ngValue]="1">1</option>
                  <option [ngValue]="2">2</option>
                  <option [ngValue]="3">3</option>
                  <option [ngValue]="4">4</option>
                  <option [ngValue]="5">5</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btnConfirm btnLabel" data-bs-dismiss="modal" (click)="resetAddMedForm()">Cancel</button>
        <button type="button" class="btn fastBtn btnLabel1" (click)="addMedication()">Add Medication</button>
      </div>
    </div>
  </div>
</div>